module.exports = __webpack_public_path__ + "img/626b9dcb863bb.05d62758.jpg";